import type { FC } from 'react';
import { Helmet } from 'react-helmet-async';
// mantine
import { Tabs } from '@mantine/core';
// icons
import { BetweenHorizontalStart, Database } from 'lucide-react';
import { AccountRole } from '@newo/api/gateway';
// components
import Header from '@/components/Layout/components/Header/Header';
import Storages from '@/pages/VersionControl/components/Storages';
import Registries from '@/pages/VersionControl/components/Registries';
// utils
import { useAccountQuery } from '@/services/customer/account/account.queries';
import { FF_PROJECTS_V2, useFeatureFlag } from '@/hooks/useFeatureFlag';
import { PageContainer } from '@/components/PageContainer/PageContainer.tsx';

const VersionControl: FC = () => {
    const { data: account } = useAccountQuery();
    const { enabled: isProjectsV2Enabled, isResolved } =
        useFeatureFlag(FF_PROJECTS_V2);
    const isAdmin = account?.role === AccountRole.Admin;

    if (!isResolved) {
        return;
    }

    return (
        <div className="w-full">
            <Helmet>
                <title>NEWO - Projects</title>
            </Helmet>
            <Header breadcrumbs={[{ label: 'Version Control' }]} />
            <PageContainer className="pt-5">
                <Tabs
                    defaultValue={
                        isProjectsV2Enabled ? 'registries' : 'storages'
                    }
                    keepMounted={false}
                >
                    <Tabs.List>
                        {isProjectsV2Enabled ? undefined : (
                            <Tabs.Tab
                                leftSection={<Database />}
                                value="storages"
                            >
                                Storages
                            </Tabs.Tab>
                        )}
                        <Tabs.Tab
                            leftSection={<BetweenHorizontalStart />}
                            value="registries"
                        >
                            Registries
                        </Tabs.Tab>
                    </Tabs.List>
                    {isProjectsV2Enabled ? undefined : (
                        <Tabs.Panel className="py-4" value="storages">
                            <Storages isAdmin={isAdmin} />
                        </Tabs.Panel>
                    )}
                    <Tabs.Panel className="py-4" value="registries">
                        <Registries isProjectsV2Enabled={isProjectsV2Enabled} />
                    </Tabs.Panel>
                </Tabs>
            </PageContainer>
        </div>
    );
};

export default VersionControl;
